import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FooterSection() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  return <>
      <footer className="bg-cream border-t border-gold/15 py-10 px-4 sm:px-6" data-id="element-16">
        <div className="max-w-4xl mx-auto" data-id="element-17">
          {/* Brand */}
          <div className="text-center mb-6" data-id="element-18">
            <p className="font-serif font-bold text-brown text-lg tracking-wide" data-id="element-19">
              El Método Hogar Dorado
            </p>
            <p className="text-brown-light/60 text-xs mt-1" data-id="element-20">
              © {new Date().getFullYear()} Todos los derechos reservados.
            </p>
          </div>

          {/* Legal Links */}
          <div className="flex items-center justify-center gap-6 mb-8" data-id="element-21">
            <button onClick={() => setActiveModal('terms')} className="text-xs text-brown-light/70 hover:text-gold underline underline-offset-2 transition-colors" data-id="element-22">
              Términos y Condiciones
            </button>
            <span className="text-brown-light/30 text-xs" data-id="element-23">·</span>
            <button onClick={() => setActiveModal('privacy')} className="text-xs text-brown-light/70 hover:text-gold underline underline-offset-2 transition-colors" data-id="element-24">
              Política de Privacidad
            </button>
            <span className="text-brown-light/30 text-xs" data-id="element-25">·</span>
            <a href="mailto:soporte@hogardorado.com" className="text-xs text-brown-light/70 hover:text-gold underline underline-offset-2 transition-colors" data-id="element-26">
              Contacto
            </a>
          </div>

          {/* Disclaimer */}
          <div className="border-t border-gold/10 pt-6 max-w-3xl mx-auto text-center" data-id="element-27">
            <p className="text-[11px] leading-relaxed text-brown-light/50 italic" data-id="element-28">
              Los resultados mencionados en esta página son ejemplos reales pero
              no garantizan resultados idénticos para todas las personas. Los
              ingresos dependen del esfuerzo, dedicación y circunstancias
              individuales de cada usuaria. Este producto es una guía educativa
              y no constituye asesoramiento financiero, legal o profesional.
            </p>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-29">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-brown/60 backdrop-blur-sm px-4" onClick={() => setActiveModal(null)} data-id="element-30">
            <motion.div initial={{
          y: 60,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: 60,
          opacity: 0
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="bg-cream rounded-t-3xl sm:rounded-3xl w-full max-w-lg max-h-[80vh] overflow-y-auto shadow-2xl border border-gold/20" onClick={e => e.stopPropagation()} data-id="element-31">
              <div className="sticky top-0 bg-cream border-b border-gold/10 px-6 py-4 flex items-center justify-between rounded-t-3xl" data-id="element-32">
                <h3 className="font-serif font-bold text-brown text-lg" data-id="element-33">
                  {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-brown-light/60 hover:text-brown transition-colors text-2xl leading-none" data-id="element-34">
                  ×
                </button>
              </div>

              <div className="px-6 py-6 text-sm text-brown-light leading-relaxed space-y-4 font-sans" data-id="element-35">
                {activeModal === 'terms' ? <>
                    <p data-id="element-36">
                      <strong className="text-brown" data-id="element-37">1. Aceptación</strong>
                      <br data-id="element-38" />
                      Al adquirir el Método Hogar Dorado, aceptas estos términos
                      en su totalidad. El acceso es personal e intransferible.
                    </p>
                    <p data-id="element-39">
                      <strong className="text-brown" data-id="element-40">
                        2. Producto Digital
                      </strong>
                      <br data-id="element-41" />
                      Este es un producto digital de descarga inmediata. Una vez
                      entregado el acceso, no se realizan devoluciones salvo
                      bajo la garantía de 30 días estipulada.
                    </p>
                    <p data-id="element-42">
                      <strong className="text-brown" data-id="element-43">
                        3. Garantía de 30 Días
                      </strong>
                      <br data-id="element-44" />
                      Si dentro de los primeros 30 días no estás satisfecha,
                      escríbenos a soporte@hogardorado.com y te devolvemos el
                      100% de tu pago sin preguntas.
                    </p>
                    <p data-id="element-45">
                      <strong className="text-brown" data-id="element-46">
                        4. Propiedad Intelectual
                      </strong>
                      <br data-id="element-47" />
                      Todo el contenido de esta guía es propiedad exclusiva de
                      El Método Hogar Dorado. Queda prohibida su reproducción o
                      distribución sin autorización escrita.
                    </p>
                    <p data-id="element-48">
                      <strong className="text-brown" data-id="element-49">5. Resultados</strong>
                      <br data-id="element-50" />
                      Los resultados varían según el esfuerzo y dedicación de
                      cada persona. No garantizamos ingresos específicos.
                    </p>
                  </> : <>
                    <p data-id="element-51">
                      <strong className="text-brown" data-id="element-52">
                        1. Datos que Recopilamos
                      </strong>
                      <br data-id="element-53" />
                      Solo recopilamos tu nombre y correo electrónico para
                      entregarte el producto y enviarte comunicaciones
                      relacionadas.
                    </p>
                    <p data-id="element-54">
                      <strong className="text-brown" data-id="element-55">
                        2. Uso de tu Información
                      </strong>
                      <br data-id="element-56" />
                      Tu información nunca será vendida ni compartida con
                      terceros. La usamos únicamente para entregarte el acceso a
                      tu compra y soporte.
                    </p>
                    <p data-id="element-57">
                      <strong className="text-brown" data-id="element-58">3. Seguridad</strong>
                      <br data-id="element-59" />
                      Todos los pagos se procesan a través de plataformas
                      seguras y encriptadas. No almacenamos datos de tarjetas de
                      crédito.
                    </p>
                    <p data-id="element-60">
                      <strong className="text-brown" data-id="element-61">4. Comunicaciones</strong>
                      <br data-id="element-62" />
                      Puedes cancelar la suscripción a nuestros correos en
                      cualquier momento haciendo clic en "cancelar suscripción"
                      al pie de cualquier email.
                    </p>
                    <p data-id="element-63">
                      <strong className="text-brown" data-id="element-64">5. Contacto</strong>
                      <br data-id="element-65" />
                      Para cualquier consulta sobre tu privacidad, escríbenos a
                      soporte@hogardorado.com.
                    </p>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}